<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="310012"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>filter.isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="success"
              @click="toEdit"
            >{{ $t('SeaExport.Edit') }}</el-button>
            <el-button
              type="success"
              @click="toPrint"
            >{{ $t('SeaExport.print') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="310012"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="310012"
            :total="allNumber"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            layout="total, slot"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
    <land-transportation-form
      ref="landForm"
      :visible="landTransportationFormDialog.visible"
      :data="landTransportationFormDialog.data"
      @close="onLandTransportationFormDialogClose"
      @save="onSave"
      @print="onPrint"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
      :printed-callback="templateSelectorDialog.printedCallback"
      :v2-check-callback="templateSelectorDialog.printedCallback"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as TruckingInfoPrintState from '@/class/cargo/model/parameters/TruckingInfoPrintState'
import { getLoading } from '@/utils/utilBaseElement'
import { queryLandTransportation, queryTruckingInfo, saveTruckingInfo } from '@/api/seaExport/trucking'
import StrUtils from '@/utils/StrUtils'
import LandTransportationForm from '@/views/cargo/v0/SeaExport/LandTransportation/components/LandTransportationForm'
import { getJobByUuid } from '@/api/booking/job'
import { Job } from '@/class/model/booking/Job'
import { PrintUtils } from '@/utils/PrintUtils'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CustomLableUtils from '@/utils/CustomLabelUtils'
export default {
  name: 'LandTransportation',
  components: { CargoTemplateSelectDialog, LandTransportationForm, searchItem },
  data() {
    return {
      fullscreenLoading: false,
      total: 0,
      data: {},
      landTransportationFormDialog: {
        visible: false,
        data: {}
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'LOCALSERVICE',
        data: {},
        ctx: null,
        printedCallback: null
      },
      filter: {
        isAdvancedQuery: false,
        jobNo: '',
        pageNum: 1,
        pageSize: 40,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDoubleClicked: (e) => this.onRowDoubleClicked(e),
        onRowClicked: (e) => this.onRowClicked(e),
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        }
      },
      rowData: [],
      allNumber: 0,
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: false,
              routeName: 'SeaBooking',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('route.bookingNew'),
              routePermissions: ['module_fmBookingNew']
            }
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCompany'), field: 'carryingCmp', colId: 'carryingCmp', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageNo'), field: 'truckOrderNo', colId: 'truckOrderNo', width: 100
        },
        {
          headerName: this.$t('SeaExport.Customer'), field: 'customerId', colId: 'customerId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfLoading'), field: 'loadingPortCode', colId: 'loadingPortCode', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'), field: 'dischargingPortCode', colId: 'dischargingPortCode', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'), field: 'etd', colId: 'etd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 100
        },
        {
          headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 100
        },
        {
          headerName: this.$t('SeaExport.Mbl2'), field: 'mbl', colId: 'mbl', width: 100
        },
        {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'), field: 'loadingDate', colId: 'loadingDate', width: 100
        },
        {
          headerName: this.$t('SeaExport.BookingAgent'), field: 'bookingAgent', colId: 'bookingAgent', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: 'S/O No.', field: 'soNo', colId: 'soNo', width: 100
        },
        {
          headerName: this.$t('SeaExport.Operation'), field: 'opId', colId: 'opId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Status'), field: 'jobState', colId: 'jobState', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.TeamContact'), field: 'driver', colId: 'driver', width: 100
        },
        {
          headerName: this.$t('SeaExport.ContactNumber'), field: 'driverTel', colId: 'driverTel', width: 100
        },
        {
          headerName: this.$t('SeaExport.Door'), field: 'doorName', colId: 'doorName', width: 100
        },
        {
          headerName: this.$t('SeaExport.DoorContact'), field: 'doorMan', colId: 'doorMan', width: 100
        },
        {
          headerName: this.$t('SeaExport.DoorContactNumber'), field: 'doorManTel', colId: 'doorManTel', width: 100
        },
        {
          headerName: this.$t('SeaExport.PrintStatus'), field: 'printState', colId: 'printState', width: 100,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(TruckingInfoPrintState.TRUCKINGINFO_PRINT_STATES, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCharge'), field: 'truckingFee', colId: 'truckingFee', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        {
          headerName: this.$t('SeaExport.DoorAddress'), field: 'doorAddr', colId: 'doorAddr', width: 100
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          },
          hide: true,
          width: 200
        },
        {
          headerName: this.$t('SeaExport.BookingNo'),
          field: 'bookingNo',
          colId: 'bookingNo',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DateOfArrival3'),
          field: 'eta',
          colId: 'eta',
          enableRowGroup: true,
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CYOpeningTime'),
          field: 'terminalOpendate',
          colId: 'terminalOpendate',
          hide: true,
          width: 150,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DocCutOffDate'),
          field: 'fileCutoff',
          colId: 'fileCutoff',
          enableRowGroup: true,
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.formatContainerDescFunc(params.value)
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.EquipmentEstimatedReturnTimeTo'),
          field: 'returnPeriodEnd',
          colId: 'returnPeriodEnd',
          enableRowGroup: true,
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DoorRemarks'),
          colId: 'doorRemarks',
          field: 'doorRemarks',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.ZIP'),
          colId: 'zipCode',
          field: 'zipCode',
          width: 180,
          enableRowGroup: true,
          hide: true
        }
      ]
    }
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    onRowClicked(e) {
      this.selectRow = e.data
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeJob = node.data
            if (nodeJob.jobUuid) this.selectRow = nodeJob
          }
        })
      }
    },
    onRowDoubleClicked(e) {
      this.edit(e.data)
    },
    toQuery() {
      if (this.filter.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toSimpleQuery(keyword) {
      if (StrUtils.isEmpty(keyword)) {
        this.$message.warning(this.$t('SeaExport.Prompt1'))
        return
      }
      this.filter.jobNo = keyword
      this.query()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filter.conditions = [... data]
      }
      this.query()
    },
    query() {
      this.fullscreenLoading = getLoading()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryLandTransportation(this.filter).then(res => {
        this.fullscreenLoading.close()
        this.rowData = null
        this.allNumber = 0
        if (res.data) {
          this.rowData = res.data.list
          this.allNumber = res.data.count
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toEdit() {
      this.edit(this.selectRow)
    },
    edit(data) {
      if (!data) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
      }
      queryTruckingInfo({ truckingInfoUuid: data.truckingUuid }).then(res => {
        this.data = res.data
        this.landTransportationFormDialog.visible = true
        this.landTransportationFormDialog.data = res.data
        this.$nextTick(() => {
          this.$refs['landForm'].loadContacts()
        })
      })
    },
    toPrint() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
      }
      queryTruckingInfo({ truckingInfoUuid: this.selectRow.truckingUuid }).then(res => {
        this.data = res.data
        this.onPrint(res.data)
      })
    },
    onLandTransportationFormDialogClose() {
      this.landTransportationFormDialog.visible = false
      this.landTransportationFormDialog.data = {}
    },
    reloadSelectRow(data) {
      this.rowData.forEach(item => {
        if (item.truckingUuid === data.uuid) {
          item.driver = data.driver
          item.driverTel = data.driverTel
          item.printState = data.printState
        }
      })
      this.gridOptions.api.setRowData(this.rowData)
    },
    onPrint(data) {
      const { jobUuid, truckingUuid } = data
      const params = {
        jobuuid: jobUuid,
        truckinguuid: truckingUuid,
        JOB_UUID: jobUuid
      }
      getJobByUuid(jobUuid).then(res => {
        this.templateSelectorDialog.visible = true
        this.templateSelectorDialog.ctx = new Job(res.data)._data
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.printedCallback = this.printedCallback
      })
    },
    onSave(data) {
      this.fullscreenLoading = getLoading()
      saveTruckingInfo(data).then((res) => {
        this.fullscreenLoading.close()
        this.$message.success(this.$t('Pricing.SavedSucceed'))
        this.reloadSelectRow(data)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    printedCallback(event) {
      this.templateSelectorDialog.visible = false
      this.landTransportationFormDialog.visible = false
      if ((event.action === PrintUtils.PRINT || event === true) && this.data.printState === 0) {
        this.data.printState = 1
        this.onSave(this.data)
      }
    }
  }
}
</script>

<style scoped>

</style>
